import { defineComponent as _defineComponent } from 'vue'
import { Typo, Toast } from '@travelata-libs/ui-kit';
    import { useViewport } from '@travelata-libs/utils';
    import { type FsaRegistryInfo } from '../model/types';

    interface FsaRegistry {
        fsaRegistryInfo: FsaRegistryInfo;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'FsaRegistry',
  props: {
    fsaRegistryInfo: null
  },
  setup(__props: any) {

    

    const { isMobile } = useViewport();

return { __sfc: true,isMobile, Typo, Toast }
}

})